module.exports = __webpack_public_path__ + "img/pole.f9bc6395.png";